export default {
  overviewTitle: 'Planning',
  url: '/planning',
  filterName: 'planning',
  apiUrl: '/jobs/planning'
};
